import type { DocumentFragment } from '~app/graph/generated/graphql'

type Customer = NonNullable<DocumentFragment['customer']>

export const NO_CUSTOMER: Customer = {
  __typename: 'Customer',
  id: 'N/A',
  encodedPublicId: 'N/A',
  planId: 'N/A',
  email: 'N/A',
  companyName: 'N/A',
  firstName: 'No',
  lastName: 'Customer',
  scanCenter: 'HAM' as Customer['scanCenter'],
  returnsAll: false,
  createdAt: null,
  updatedAt: null,
} as const
